"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputChar = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const emoji_picker_react_1 = tslib_1.__importStar(require("emoji-picker-react"));
const Input_1 = require("../Input");
const BasicButton_1 = require("../BasicButton");
const Popup_1 = require("../../4-card/Popup");
const context_1 = require("../../4-card/Popup/context");
const ClickAway_1 = require("../../utils/ClickAway");
const Flex_1 = require("../../3-list-item/Flex");
const context_2 = require("../../styles/context");
const buttonInnerClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    jc: 'center',
    fz: '20px',
    lh: 1,
    minW: '24px',
});
const stopPointerPropagation = (event) => {
    event.stopPropagation();
};
const preventPopupMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
};
const EmojiPickerInner = ({ light, onSelect }) => {
    const popup = (0, context_1.usePopup)();
    const handleClickAway = React.useCallback(() => popup?.close(), [popup]);
    return (React.createElement(ClickAway_1.ClickAway, { onMouseDown: stopPointerPropagation, onMouseUp: stopPointerPropagation, onClick: stopPointerPropagation, onClickAway: handleClickAway },
        React.createElement(emoji_picker_react_1.default, { theme: light ? emoji_picker_react_1.Theme.LIGHT : emoji_picker_react_1.Theme.DARK, height: 360, width: 350, skinTonePickerLocation: emoji_picker_react_1.SkinTonePickerLocation.PREVIEW, onEmojiClick: (data) => {
                onSelect(data.emoji);
                popup?.close();
            } })));
};
const takeLastCodePoint = (text) => {
    if (!text)
        return '';
    const points = Array.from(text);
    return points[points.length - 1] ?? '';
};
const takeLastTwoCodePoints = (text) => {
    if (!text)
        return '';
    const points = Array.from(text);
    return points.slice(-2).join('');
};
const InputChar = (props) => {
    const { emoji, emojiPlaceholder = '🙂', value = '', onChange, onFocus, disabled, readOnly, ...rest } = props;
    const styles = (0, context_2.useStyles)();
    const handleFocus = React.useCallback((event) => {
        const input = event.target;
        requestAnimationFrame(() => {
            try {
                input.select();
            }
            catch { }
        });
        onFocus?.(event);
    }, [onFocus]);
    const emojiOnly = emoji === 'only';
    const emojiEnabled = !!emoji;
    const locked = !!disabled || !!readOnly;
    const handleChange = React.useCallback((text) => {
        const next = emojiEnabled ? takeLastTwoCodePoints(text) : takeLastCodePoint(text);
        onChange?.(next);
    }, [emojiEnabled, onChange]);
    const handlePick = React.useCallback((picked) => {
        onChange?.(picked);
    }, [onChange]);
    const renderEmojiPicker = React.useCallback(() => React.createElement(EmojiPickerInner, { light: !!styles.light, onSelect: handlePick }), [handlePick, styles.light]);
    let button = null;
    if (emojiEnabled) {
        const buttonEl = (React.createElement(BasicButton_1.BasicButton, { type: "button", fill: true, width: 48, height: 36, rounder: true, disabled: locked, onMouseDown: locked ? undefined : preventPopupMouseDown },
            React.createElement("span", { className: buttonInnerClass }, value || emojiPlaceholder)));
        button = locked ? buttonEl : React.createElement(Popup_1.Popup, { renderContext: renderEmojiPicker }, buttonEl);
    }
    if (emojiOnly) {
        return React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center' } }, button);
    }
    return (React.createElement(Flex_1.Flex, { style: { gap: 8, alignItems: 'center' } },
        React.createElement(Input_1.Input, { ...rest, type: "text", value: value, disabled: disabled, readOnly: readOnly, onChange: handleChange, onFocus: handleFocus }),
        button));
};
exports.InputChar = InputChar;
